// extracted by mini-css-extract-plugin
export default {"button":"TopicItemMenu-module__button--XjC1B","active":"TopicItemMenu-module__active--eZF1w","animatedBackground":"TopicItemMenu-module__animatedBackground--S5oXV"};